import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import AllegatiQuestionario from './AllegatiQuestionario';
import ListaContenutiSimili from './ListaContenutiSimili';
import Oggetto from './Oggetto';
import Messaggio from './Messaggio';
import useDeferredChangeOggettoMessaggio from './useDeferredChangeOggettoMessaggio';

/**
*/
const InserisciQuesito = ({
  nessunSuggerimentoComponent, fileUploadHelper, codiceArea, ufficioSelezionato,
  oggetto, messaggio, onChangeOggetto, onChangeMessaggio, allegati, onChangeAllegati, onUploadingAllegatoChange,
}) => {
  const [defOggetto, handleChangeOggetto, defMessaggio, handleChangeMessaggio] = useDeferredChangeOggettoMessaggio(onChangeOggetto, onChangeMessaggio);

  const infoModaleQuesito = useMemo(() => {
    if (allegati.length === 0 && isTestoQuestitoConAllegato(messaggio)) {
      return {
        type: 'warning',
        htmlMessage: 'Forse ti sei dimenticato di allegare un file',
      };
    }
    if (fileUploadHelper) {
      return {
        type: 'info',
        htmlMessage: fileUploadHelper,
      };
    }
    return null;
  }, [allegati.length, fileUploadHelper, messaggio]);

  return (
    <div className="helpdesk-frontend-step helpdesk-frontend-questionario">
      <div className="helpdesk-frontend-questionario__dati">
        <div className="helpdesk-frontend-questionario__contenuto">
          <Oggetto
            value={oggetto}
            onChange={handleChangeOggetto}
          />
          <Messaggio
            value={messaggio}
            onChange={handleChangeMessaggio}
          />
        </div>
        <div className="helpdesk-frontend-questionario__soluzioni">
          <ListaContenutiSimili
            ufficioSelezionato={ufficioSelezionato}
            titolo={defOggetto}
            messaggio={defMessaggio}
            codiceArea={codiceArea}
            nessunSuggerimentoComponent={nessunSuggerimentoComponent}
          />
        </div>
      </div>
      <div className="helpdesk-frontend-questionario__allegati">
        <AllegatiQuestionario
          infoModaleQuesito={infoModaleQuesito}
          allegati={allegati}
          onAddAllegato={(allegato) => onChangeAllegati(() => [...allegati, allegato])}
          onRemoveAllegato={(allegato) => onChangeAllegati(() => allegati.filter((f) => f !== allegato))}
          onChageUploading={onUploadingAllegatoChange}
        />
      </div>
    </div>
  );
};

InserisciQuesito.propTypes = {
  nessunSuggerimentoComponent: PropTypes.node,
  fileUploadHelper: PropTypes.string,
  codiceArea: PropTypes.string,
  ufficioSelezionato: PropTypes.string,

  onChangeOggetto: PropTypes.func.isRequired,
  oggetto: PropTypes.string,

  onChangeMessaggio: PropTypes.func.isRequired,
  messaggio: PropTypes.string,

  onChangeAllegati: PropTypes.func.isRequired,
  allegati: PropTypes.arrayOf(PropTypes.shape({

  })),

  onUploadingAllegatoChange: PropTypes.func.isRequired,
};

InserisciQuesito.defaultProps = {
  nessunSuggerimentoComponent: undefined,
  ufficioSelezionato: undefined,
  codiceArea: undefined,
  fileUploadHelper: undefined,
  oggetto: '',
  messaggio: '',
  allegati: [],
};

export default InserisciQuesito;

function isTestoQuestitoConAllegato(messaggio) {
  if (!messaggio) return false;
  return messaggio.toLowerCase().indexOf('allego') !== -1
    || messaggio.toLowerCase().indexOf('alleghiamo') !== -1
    || messaggio.toLowerCase().indexOf('allegato') !== -1
    || messaggio.toLowerCase().indexOf('allegati') !== -1
    || messaggio.toLowerCase().indexOf('allega') !== -1;
}
